module.exports = __webpack_public_path__ + "static/media/loading.e8371723.svg";